import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../assets/styles/AppSummary.scss";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import TuneIcon from "@mui/icons-material/Tune";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

function AppSummary() {
  useEffect(() => {
    AOS.init({ duration: 900, once: true, easing: "ease-out-cubic" });
  }, []);

  return (
    <div className="app-summary-container">
      <div className="app-summary-content" data-aos="fade-up">
        <span className="section-eyebrow">Why Goal Guru</span>
        <h2 className="section-title">Football That Actually Matters</h2>
        <p className="summary-body">
          Stop drowning in notifications. Goal Guru learns what you care about
          and delivers only the football moments that excite you — your favorite
          teams, leagues, and the games that deserve your attention.
        </p>

        <div className="motto-container">
          <div className="pillar" data-aos="fade-up" data-aos-delay="100">
            <div className="pillar-icon-wrap">
              <NotificationsActiveIcon className="pillar-icon" />
            </div>
            <h3 className="motto-text">Smart Alerts</h3>
            <p className="pillar-description">
              Trigger on any live condition — goals, corners, cards, momentum
              shifts, and more.
            </p>
          </div>
          <div className="pillar" data-aos="fade-up" data-aos-delay="220">
            <div className="pillar-icon-wrap">
              <TuneIcon className="pillar-icon" />
            </div>
            <h3 className="motto-text">Personalized</h3>
            <p className="pillar-description">
              Your leagues, your teams, your conditions. Fully customizable from
              day one.
            </p>
          </div>
          <div className="pillar" data-aos="fade-up" data-aos-delay="340">
            <div className="pillar-icon-wrap">
              <AutoAwesomeIcon className="pillar-icon" />
            </div>
            <h3 className="motto-text">AI Powered</h3>
            <p className="pillar-description">
              Guru Vision analyses live stats, recent form, and head-to-head
              history to surface data-driven insights on how a match is
              developing.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppSummary;
